import React, { ReactElement, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

import { Typography, Flex, Box, Row, Col } from 'components';

import Term from './Term';

import {
  Wrapper,
  ContentWrapper,
  //   Header,
  //   HeaderContent,
  // DownloadIcon,
  // DocumentTypography,
  Square,
  LinkButton,
  // LinkButtonDisabled,
  TermsLink,
  // AlertIcon,
  //   HeaderWrapper,
  // FlexDownload,
  // MobileBreak,
  Header,
  Overlay,
  // SquareLines,
  // Plus,
} from './styles';

const HeaderOverlay = styled(Flex)`
  width: 100%;
  height: 100%;
  background: url('/images/headerOverlay.png');
  position: absolute;
  background-size: cover;
  top: 0;
  left: 0;
`;

const SquareLines = styled('i')`
  position: relative;
  position: absolute;
  width: 0px;
  height: 0px;

  &::after {
    content: '';
    display: block;
    background-color: ${({ theme }) => theme.colors.primary_200};
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
  }

  &::before {
    content: '';
    display: block;
    border-top: 1px solid ${({ theme }) => theme.colors.dark_350};
    border-right: 1px solid ${({ theme }) => theme.colors.dark_350};
    position: absolute;

    right: -1px;
    z-index: 1;
  }

  ${({ theme: { mediaQueries } }) => {
    return `
        ${mediaQueries.mobile} {
          left: -20px;
          top: 1px;

          &::after {
            width: 14px;
            height: 14px;
          }

          &::before {
            top: -40px;
            width: 150px;
            height: 300px;
          }
        }

        ${mediaQueries.tablet} {
          left: -30px;
          top: -2px;

          &::after {
            width: 18px;
            height: 18px;
          }

          &::before {
            top: -40px;
            width: 300px;
            height: 400px;
          }
        }

        ${mediaQueries.desktop} {
          left: -40px;
          top: 0px;

          &::after {
            width: 24px;
            height: 24px;
          }

          &::before {
            top: -60px;
            width: 150px;
            height: 550px;
          }
        }
      `;
  }}
`;

const GlobalStyle = createGlobalStyle`
    body {
        background: ${({ theme }) => theme.colors.black80};
    }
`;

const Imersao = (): ReactElement => {
  const [showTerm, setShowTerm] = useState(false);

  const hideTerm = () => {
    setShowTerm(false);
  };

  return (
    <>
      {showTerm && <Term hideTerm={hideTerm} />}

      <Wrapper>
        {/* <Flex
          flexGrow={0}
          minHeight={{ m: 240, t: 360, d: 500 }}
          backgroundImage={`url(/images/Header-curso6.jpg)`}
          backgroundSize="cover"
          position="relative"
        >
          <HeaderOverlay alignItems="center">
            <Section
              maxWidth={{ m: 280, t: '90%', d: 950 }}
              bg="red"
              position="relative"
              alignItems="center"
              mx="inherit"
              px={{ m: 20, t: 30 }}
            >
              <Flex position="relative" flexGrow={0} flexDirection="column" maxWidth={{ d: 500 }}>
                <SquareLines />

                <Typography type="type5" fontWeight="bold" color="white" upper>
                  FRATERNIDADE
                </Typography>

                <Typography
                  as="h1"
                  type="type10"
                  fontWeight="bold"
                  color="white"
                  mt={{ m: '10px', t: 15 }}
                >
                  MELVER
                </Typography>
              </Flex>
            </Section>
          </HeaderOverlay>
        </Flex> */}

        <Header>
          <HeaderOverlay>
            <Overlay pt={{ m: 80, t: 150, d: 250 }} pr={{ m: 40, t: 60, d: 100 }} pb={{ m: 40, t: 60, d: 100 }} pl={{ m: 60, t: 120, d: 230 }}>
              <Flex zIndex={15} flexDirection="column">
                <Typography type="type6" fontWeight="bold" color="white" upper style={{ position: 'relative' }}>
                  <SquareLines />
                  FRATERNIDADE
                </Typography>

                <Typography type="type10" fontWeight="bold" color="white" mt={{ m: 1, t: '10px' }}>
                  MELVER
                </Typography>
                {/* 
              <Typography color="white" type="type2" mt={{ m: 3, t: 20, d: 40 }} lineHeight={1.3}>
                A Fraternidade MELVER é um programa exclusivo para ex-alunos(as) dos programas de
                mentoria da MELVER. A Fraternidade busca pessoas que querem trabalhar em rede para a
                construção de uma sociedade melhor, mais equânime e justa, impactando positivamente
                a vida das pessoas, tendo como base uma compreensão holística delas.
              </Typography> */}
              </Flex>
            </Overlay>
          </HeaderOverlay>
        </Header>

        <Flex bg="gray_300" py={{ m: 40, d: 60 }} px={{ m: 20 }}>
          <ContentWrapper>
            <Flex flexDirection="column">
              <Typography color="black80" upper>
                DETALHES SOBRE A FRATERNIDADE
              </Typography>
              <Typography type="type7" color="black" fontWeight="bold" mt={1}>
                Empoderar para evoluir vidas
              </Typography>
            </Flex>

            <Row gutter={50} mt={{ m: 3, d: 5 }} alignItems="flex-start">
              <Col width={{ m: 1, t: 2 / 3 }}>
                <Typography color="black80" lineHeight={1.5}>
                  A Fraternidade MELVER é um programa exclusivo para ex-alunos(as) dos programas de mentoria da MELVER. A Fraternidade busca pessoas
                  que querem trabalhar em rede para a construção de uma sociedade melhor, mais equânime e justa, impactando positivamente a vida das
                  pessoas, tendo como base uma compreensão holística delas.
                </Typography>
              </Col>

              <Col width={{ m: 1, t: 1 / 2 }} mt={{ m: 4, t: 0 }} />
            </Row>
          </ContentWrapper>
        </Flex>

        <Flex bg="dark_350" py={{ m: 40, d: 60 }} px={{ m: 20 }}>
          <ContentWrapper>
            <Row>
              <Col width={{ m: 1, t: 1 / 2 }}>
                <Flex flexDirection="column" pr={4} justifyContent="flex-start">
                  <Typography upper color="white" fontWeight="bold">
                    Conhecimento
                  </Typography>

                  <Typography color="white50" mt={3} lineHeight={1.5}>
                    <ul style={{ margin: 0, padding: 0, paddingLeft: 15 }}>
                      <li>Utilização da Roda da Vida para crescimento pessoal; </li>
                      <li>Geração de impacto social com a Roda da Vida; </li>
                      <li>Elaboração de Planos de Ação Metrificáveis; </li>
                      <li>Aplicação diária de Rounds; </li>
                      <li>Aplicação diária da Lista contra a Procrastinação; </li>
                      <li>Montagem do Ikigai. </li>
                    </ul>
                  </Typography>
                </Flex>
              </Col>

              <Col width={{ m: 1, t: 1 / 2 }}>
                <Flex flexDirection="column" justifyContent="flex-start" mt={{ m: 50, d: 0 }}>
                  <Typography upper color="white" fontWeight="bold">
                    Detalhes
                  </Typography>

                  <Typography color="white50" mt={3} lineHeight={1.5}>
                    <ul style={{ margin: 0, padding: 0, paddingLeft: 15 }}>
                      <li>Lives mensais sobre uma das quatro áreas da Roda da Vida;</li>
                      <li>Desafios mensais;</li>
                      <li>Network.</li>
                    </ul>
                  </Typography>
                </Flex>
              </Col>
            </Row>
          </ContentWrapper>
        </Flex>

        <Flex bg="white" py={{ m: 40, d: 60 }} px={{ m: 20 }}>
          <ContentWrapper>
            <Flex flexDirection="column">
              <Typography color="black80" upper>
                Formato
              </Typography>
              <Typography type="type7" color="black" fontWeight="bold" mt={1}>
                Metodologia de aprendizagem
              </Typography>
            </Flex>

            <Row gutter={50} mt={{ m: 3, d: 5 }} alignItems="flex-start">
              <Col width={{ m: 1, t: 1 / 2 }}>
                <Typography color="black80" lineHeight={1.5}>
                  <p>
                    <strong>Duas vezes por mês, os participantes reunir-se-ão em encontros on-line. Em cada mês,</strong>
                    <strong> uma das quatro áreas da Roda da Vida</strong> (Pessoal; Profissional; Relacionamentos e Qualidade de Vida) será
                    aprofundada. Os participantes serão provocados a otimizarem cada uma dessas áreas continuamente por meio de técnicas desenvolvidas
                    pela equipe MELVER.
                  </p>
                </Typography>
              </Col>

              <Col width={{ m: 1, t: 1 / 2 }} mt={{ m: 4, t: 0 }}>
                <Flex flexDirection="column">
                  <Typography fontWeight="bold">Lives</Typography>
                  <Typography mt={1}>Encontros on-line para discussão de um determinado tema.</Typography>

                  <Typography fontWeight="bold" mt={4}>
                    Desafios
                  </Typography>
                  <Typography mt={1}>Desafios mensais atrelados ao tema do mês.</Typography>
                </Flex>
              </Col>
            </Row>
          </ContentWrapper>
        </Flex>

        <ContentWrapper>
          <Flex mt={{ m: 30, d: 120 }} px={{ m: 20, d: 0 }} pt={{ m: 20, d: 0 }} flexDirection="column">
            <Typography type="type7" color="white" fontWeight="bold" upper>
              Forma de
            </Typography>

            <Typography type="type10" color="white" fontWeight="bold" upper>
              Pagamento
            </Typography>
          </Flex>

          <Flex mx={{ d: 0 }} mt={{ m: 20, d: 30 }}>
            <Row gutter={30}>
              <Col width={{ m: 1, t: 1 / 2 }}>
                <Flex mx={{ m: 20, d: 0 }} flexDirection="column" px={{ m: 30, d: 50 }} pb={{ m: 30, d: 40 }} borderRadius={4} bg="dark_350">
                  <Flex flexDirection="column">
                    <Square />

                    <Typography type="type2" color="white" fontWeight="regular" upper mt={2}>
                      FRATERNIDADE
                    </Typography>

                    <Typography type="type5" color="white" fontWeight="bold" upper mt={1} lineHeight={1.2}>
                      MELVER
                    </Typography>

                    {/* <Typography type="type0" color="white25" mt={1}>
                      Curso on-line
                    </Typography> */}
                  </Flex>

                  <Flex flexDirection="column" flexGrow={0} mt={{ m: 3, d: 6 }}>
                    <Typography type="type5" color="white" fontWeight="bold" mt={1}>
                      12x de R$ 23,88
                    </Typography>

                    <Typography type="type1" color="white" mt={1} mb={3}>
                      Ou à vista R$ 238,80 sem juros
                    </Typography>

                    <Flex flexDirection="column">
                      <LinkButton target="_blank" href="https://app.melver.com.br/452bNVTgmq/checkout">
                        Comprar
                      </LinkButton>

                      <Typography lineHeight="1.3" type="type0" color="white25" mt={3}>
                        Ao clicar em comprar, declaro que aceito os <TermsLink onClick={() => setShowTerm(true)}>termos de uso</TermsLink> do produto.
                      </Typography>
                    </Flex>
                  </Flex>
                </Flex>
              </Col>
            </Row>
          </Flex>

          <Box flexGrow={1} textAlign="center" pt={{ m: 40, d: 100 }} pb="20px">
            <Typography lineHeight="1.4" type="type0" color="#9F9F9F">
              © Todos os direitos reservados a MELVER LTDA.
            </Typography>
          </Box>
        </ContentWrapper>
      </Wrapper>
      <GlobalStyle />
    </>
  );
};
export default Imersao;
